import { createTheme } from '@mui/material/styles';
import {
  fontFaceStyle,
  transformBrandStyle
} from '@getbento/website-components';
import get from 'lodash/get';

import { FONT_TYPES } from 'constants/brands';
import theme from 'styles/theme';
import { getPalette } from 'styles/theme/brand/palette';
import { getTypography } from 'styles/theme/brand/typography';

export const setupTheme = ({ styles, fonts = [] }) => {
  const brandStyles = get(styles, 'styles', []);
  const spacing = get(styles, 'base.padding', 8);
  const borderWidth = get(styles, 'base.borderWidth', 2);
  const borderRadius = get(styles, 'base.borderRadius', 4);

  const transformedBrandStyles = transformBrandStyle(
    theme.breakpoints,
    brandStyles,
    {
      spacing,
      borderWidth,
      borderRadius
    }
  );

  const customFonts = fonts.filter(font => font.fontType === FONT_TYPES.CUSTOM);
  const customFontFaces = customFonts.map(customFont =>
    fontFaceStyle(customFont.slug, customFont.sources)
  );

  const palette = getPalette(transformedBrandStyles);
  const typography = getTypography(transformedBrandStyles);
  const { muiCardOutline } = theme.getComponentsStyles({ palette });
  const defaultFontFaces = theme.loadDefaultFonts();
  const styleOverrides = theme.styleOverrides({
    fontFaces: [...defaultFontFaces, ...customFontFaces],
    muiCardOutline
  });
  const components = theme.createComponents(styleOverrides, theme.defaultProps);

  return createTheme({
    typography,
    palette,
    components,
    constants: theme.constants,
    fonts: theme.fonts,
    breakpoints: theme.breakpoints,
    boxShadows: {
      MuiCard: {
        base: theme.constants.boxShadows.normal,
        selected: theme.constants.boxShadows.selected
      }
    }
  });
};
